import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '0',
    right: '0',
    height: '80%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'right'
  },

  info: {
    opacity: '0.3',
    marginTop: '0.25rem'
  }
}))

export default useStyles
